
import React,{useContext, useState, useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SITE_TITLE, INDEX_URL } from '../../settings/common';
import { AppContext } from '../../helpers/AppContext';
import { decrypt } from '../../helpers/encryption';
import { seo } from '../../settings/seo';
import { Validation } from '../../helpers/validation';
import WAServices from '../../services/WAServices';
import { showSuccessMessage, showErrorMessage } from '../../helpers/flash-messages';
import { encrypt } from '../../helpers/encryption';
import { Overlay } from '../../helpers/Overlay';

const WASettingsPage = () => {
	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState({});
	const [authUser, setAuthUser] = useState({});
	const [settings, setSettings] = useState({});
    const {isSidebarHidden, setSidebarHidden } = useContext(AppContext);
    const { SharedAuthUser } = useContext(AppContext);
    const [showEdit , setShowEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const { setSharedAuthUser } = useContext(AppContext);
    const navigate = useNavigate();
    const waServices = new WAServices();

    useEffect(() => {
        const auth_user = decrypt('__bs_auth_user');
        console.log(auth_user);
        if (Object.keys(SharedAuthUser).length > 0) {
            setAuthUser(SharedAuthUser);
        } else if (auth_user) {
            setAuthUser(auth_user);
            getConfiguration(auth_user.auth_token);
        } else {
            setAuthUser({});
        }
    }, [SharedAuthUser]);

    useEffect(() => {
	    if (settings) {
	        const newFormData = {
	            phone_number_id: settings.phone_number_id,
	            client_app_id: settings.client_app_id,
	            client_secret: settings.client_secret,
	            api_token: settings.api_token,
	            whatsapp_business_account_id: settings.whatsapp_business_account_id
	        };
	        setFormData(newFormData);
	    }
	}, [settings]);

	useEffect(() => {
        seo({
            title: SITE_TITLE + ' || WhatsApp Configuration',
            metaDescription: '',
        });
    },[]);

    // useEffect(() => {
    	
    // },[settings]);

    const getConfiguration = (auth_token) => {
    	try {
    		waServices.getConfiguration(auth_token).then(response => {
    			if(typeof response !== 'undefined') {
    				const data = response.data;
    				console.log(data);
    				if(data.status === 'success') {
    					if(typeof data.data.whatsapp_configuration !== 'undefined' && data.data.whatsapp_configuration) {
    						setSettings(data.data.whatsapp_configuration);
    					}
    				}
    			} else {
    				showErrorMessage('Server error: Something went wrong. Please try again later.');
    			}
    		})
    	} catch (error) {
            // Check for server-side error (500)
            if (error.response && error.response.status === 500) {
                showErrorMessage('Server error: Something went wrong. Please try again later.');
            } else {
                // Handle other types of errors, such as network errors
                showErrorMessage('An error occurred. Please check your connection and try again.');
            }
        }
    }

    const handleClick = () =>{
        setShowEdit(!showEdit);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newFormData = {
            ...formData,
            [name]: value,
        };
        setFormData(newFormData);
    };

    const handleSubmit = (e) => {
    	e.preventDefault();
        const errors = Validation(formData,['phone_number_id', 'client_app_id', 'client_secret', 'api_token', 
        	'whatsapp_business_account_id']);
        if (Object.keys(errors).length > 0) {
          setErrors(errors);
          return;
        }
        submitForm();
    };

    const submitForm = async () => {
    	try {
    		setLoading(true);
	        waServices.setConfiguration(authUser.auth_token,formData).then(response => {
	        	const data = response.data;
	        	if(data.status === 'success') {
	        		setShowEdit(false);
	        		encrypt(data.data, '__bs_auth_user');
	        		setSharedAuthUser(data.data);
	        		showSuccessMessage(`${data.message}`);
	        	} else {
	        		showErrorMessage(`${data.message}`)
	        	}
	        	setLoading(false);
	        });
    	} catch (error) {
            setLoading(false);
            // Check for server-side error (500)
            if (error.response && error.response.status === 500) {
                showErrorMessage('Server error: Something went wrong. Please try again later.');
            } else {
                // Handle other types of errors, such as network errors
                showErrorMessage('An error occurred. Please check your connection and try again.');
            }
        }
    }

    const renderForm = () => {
    	return (
		    <React.Fragment>
		        <form className="row g-3 mb-3" onSubmit={handleSubmit}>
		            <div className="col-md-6">
		                <label htmlFor="client_secret" className="form-label">Client Secret</label>
		                {showEdit ? (
		                    <>
		                        <input
		                            type="text"
		                            id="client_secret"
		                            name="client_secret"
		                            value={formData.client_secret}
		                            onChange={handleChange}
		                            className="form-control slug-title"
		                        />
		                        {errors.client_secret && <div className="text-danger">{errors.client_secret}</div>}
		                    </>
		                ) : (
		                    <span className="form-control-plaintext slug-title">{formData.client_secret}</span>
		                )}
		            </div>
		            <div className="col-md-6">
		                <label htmlFor="client_app_id" className="form-label">Client App Id</label>
		                {showEdit ? (
		                    <>
		                        <input
		                            type="text"
		                            id="client_app_id"
		                            name="client_app_id"
		                            value={formData.client_app_id}
		                            onChange={handleChange}
		                            className="form-control slug-title"
		                        />
		                        {errors.client_app_id && <div className="text-danger">{errors.client_app_id}</div>}
		                    </>
		                ) : (
		                    <span className="form-control-plaintext slug-title">{formData.client_app_id}</span>
		                )}
		            </div>
		            <div className="col-md-6">
		                <label htmlFor="phone_number_id" className="form-label">Phone Number Id</label>
		                {showEdit ? (
		                    <>
		                        <input
		                            type="text"
		                            id="phone_number_id"
		                            name="phone_number_id"
		                            value={formData.phone_number_id}
		                            onChange={handleChange}
		                            className="form-control slug-title"
		                        />
		                        {errors.phone_number_id && <div className="text-danger">{errors.phone_number_id}</div>}
		                    </>
		                ) : (
		                    <span className="form-control-plaintext slug-title">{formData.phone_number_id}</span>
		                )}
		            </div>
		            <div className="col-md-6">
		                <label htmlFor="whatsapp_business_account_id" className="form-label">Whatsapp Business Account Id</label>
		                {showEdit ? (
		                    <>
		                        <input
		                            type="text"
		                            id="whatsapp_business_account_id"
		                            name="whatsapp_business_account_id"
		                            value={formData.whatsapp_business_account_id}
		                            onChange={handleChange}
		                            className="form-control slug-title"
		                        />
		                        {errors.whatsapp_business_account_id && <div className="text-danger">{errors.whatsapp_business_account_id}</div>}
		                    </>
		                ) : (
		                    <span className="form-control-plaintext slug-title">{formData.whatsapp_business_account_id}</span>
		                )}
		            </div>
		            <div className="col-md-12">
		                <label htmlFor="api_token" className="form-label">Api Token</label>
		                {showEdit ? (
		                    <>
		                        <input
		                            type="text"
		                            id="api_token"
		                            name="api_token"
		                            value={formData.api_token}
		                            onChange={handleChange}
		                            className="form-control here set-slug"
		                        />
		                        {errors.api_token && <div className="text-danger">{errors.api_token}</div>}
		                    </>
		                ) : (
		                    <span className="form-control-plaintext set-slug">{formData.api_token}</span>
		                )}
		            </div>
		            {showEdit && (
		                <React.Fragment>
		                    <div className="col-md-12">
		                        <button type="submit" className="cx-btn cx-btn-primary">Save</button>&nbsp;
		                        <button type="button" onClick={handleClick} className="cx-btn cx-btn-primary">Cancel</button>
		                    </div>
		                </React.Fragment>
		            )}
		        </form>
		    </React.Fragment>
		);

    }

    return (
       <React.Fragment>
           <div className={`cx-main-content ${isSidebarHidden ?'sb-hide':'' }`}>
	           <div className="cx-breadcrumb">
					<div className="cx-page-title cx-page-title-2">
						<h5>WhatsApp Settings</h5>
						<ul>
							<li><Link to={`${INDEX_URL}dashboard`}>Dashborad</Link></li>
							<li>WhatsApp Settings</li>
						</ul>
					</div>
			   </div>
			   <div className="row">
					<div className="col-xxl-12 col-xl-12 col-md-12">
						<div className="cx-card">
							<div className="cx-card-content user-details mb-m-30">

								<div className="row">
									<div className="col-sm-10">
										<h3>Details</h3>
										<div className="cx-user-detail">
											<p>Set up your account for use WhatsApp Services.</p>
										</div>
									</div>
									<div className="col-sm-2">
										<button type="button" className="btn action-btn">
											<span className="sr-only" onClick={handleClick}>
												<i className="ri-pencil-line"></i>
											</span>
										</button>
									</div>
									<div className="col-xxl-6 col-xl-12 col-md-12 col-sm-12">
										{renderForm()}
									</div>
			
								</div>
							</div>
						</div>
					</div>
			   </div>
		   </div>
		   {/* Show loading overlay when `loading` is true */}
		   {loading && (
		   		<Overlay />
		   )}
       </React.Fragment>
    );
};

export default WASettingsPage;